import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson20: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson19"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Calorie Intake</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson21"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[11.63rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[11.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>Nutrition Workout Importance?</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Pre and post workout nutrition is a topic of debate and
              controversy in the fitness world. Some argue that consuming a
              protein shake immediately after a workout is crucial for muscle
              growth, while others claim that nutrient timing is irrelevant as
              long as daily macros are met. However, we disagree with both
              extremes.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              In body recomposition, the training stimulus is key for muscle
              growth, but the timing of nutrients around the workout is also
              important for performance and recovery. Pre-workout,
              intra-workout, and post-workout nutrition each play a distinct
              role and can impact training differently.
            </p>
            <p className="m-0">&nbsp;</p>
          </div>
          <img
            className="relative w-[35.44rem] h-[31.63rem] object-cover"
            alt=""
            src="/36@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem] text-white">
          <p className="m-0">
            <b>
              <span>Body Fat Percentage</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Your current body fat level is the initial factor that
                influences the significance of peri-workout nutrition. If you
                have higher body fat, your body has more energy reserves
                available, reducing the immediate urgency of nutrient timing
                around your workout. On the other hand, individuals with lower
                body fat, who have limited energy reserves, should pay greater
                attention to periworkout nutrition. With fewer stored energy
                reserves, optimizing energy utilization from food becomes more
                crucial for them.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Total Caloric Intake</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            If you have a lower caloric intake, it is recommended to allocate a
            significant portion of your nutrient intake around your workout
            session. This ensures that your performance and recovery are not
            negatively affected by the overall lower energy intake. However, it
            doesn't mean that individuals with a higher calorie target can
            neglect periworkout nutrition. It simply means that its relative
            importance is somewhat reduced for them.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Pre-Workout Nutrition</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">{`We consider the pre-workout meal to be crucial for body recomposition. It deserves special focus as it plays a significant role in optimizing performance and creating an ideal environment for muscle building. `}</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The primary objectives of the pre-workout meal are twofold: fueling
            your training and promoting an anabolic state for muscle growth.
            Let's begin by discussing the importance of fueling your workout.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">{`The pre-workout meal should include all three macronutrients and water. To provide sustained energy during your workout, it is important to focus on the right quantity and type of carbohydrates. `}</p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Avoiding a pre-workout meal primarily composed of high glycemic
            carbs is crucial to prevent a hypoglycemic state, which can result
            in weakness, dizziness, and negatively impact training performance.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            we recommend consuming the pre-workout meal 30-120 minutes before
            training, depending on your schedule, preferences, and what provides
            you with the best energy during your lifting sessions. You can then
            adjust the composition of the meal to suit your specific needs.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            When the meal is closer to the workout, it's advisable to focus on
            consuming foods that are digested more quickly, such as whey protein
            and a banana (which has lower fiber content compared to an apple).
            In situations where time is limited, you may also reduce your total
            carbohydrate intake to ensure faster energy availability and prevent
            any overlap between digestion and training.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Your preworkout meal should consist of: • ~1g of carbohydrates per
            kg of bodyweight, coming from a low glycemic carb source plus a
            serving of fruit. • ~0.5g of protein per kg of bodyweight coming
            from a high quality protein source (or combination of sources)
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Post-Workout Nutrition</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The primary focus of the post-workout meal is to initiate the
            recovery process, with protein being the most crucial macronutrient.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            To stimulate muscle protein synthesis and facilitate muscle repair,
            we recommend consuming approximately 0.5 grams of protein per
            kilogram of bodyweight in the post-workout meal. It's best to choose
            a complete protein source such as whey, meat, poultry, or fish.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Like the pre-workout meal, it is advisable to include a fruit source
            in your post-workout meal to achieve our general nutrition goal of
            consuming two servings of fruit per day, enhancing accountability.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Post-workout nutrition should consist of: • ~0.5 g of protein per kg
            of bodyweight • ~1-1.5 grams of carbohydrate per kilogram of
            bodyweight
          </p>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson21"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson20;
